const FILTER_SEARCH = {
  FILTER_TYPES: {
    MULTI_OPTION: 'MULTI_OPTION',
    SINGLE_OPTION: 'SINGLE_OPTION',
    RANGE: 'RANGE',
    CUSTOM: 'CUSTOM'
  },
  FILTER_DISPLAY_TYPES: {
    TEXT: 'TEXT',
    SWATCH: 'SWATCH',
    RANGE: 'RANGE',
    BOX: 'BOX',
    RATING: 'RATING'
  },
  SORT_TYPES: {
    BEST_SELLING: 'best_selling',
    RELEVANCE: 'relevance',
    PRICE_ASC: 'price_asc',
    PRICE_DESC: 'price_desc',
    NAME_ASC: 'name_asc',
    NAME_DESC: 'name_desc',
    RATING_ASC: 'rating_asc',
    RATING_DESC: 'rating_desc',
    NEW_ARRIVAL_ASC: 'new_arrival_asc',
    NEW_ARRIVAL_DESC: 'new_arrival_desc'
  }

}

export default FILTER_SEARCH